/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { isFulfilled, isPending, isRejected, isRejectedWithValue, Middleware } from '@reduxjs/toolkit'
import NProgress from 'nprogress'

/**********************************************************************************************************
 *   MIDDLEWARE
 **********************************************************************************************************/
export const fetching: Middleware = () => (next) => (action) => {
    if (isPending(action)) {
        NProgress.start()
    }

    if (isFulfilled(action) || isRejected(action) || isRejectedWithValue(action)) {
        NProgress.done()
    }

    return next(action)
}
